<template>
    <div>
        <div class="light-warning-box"> 
            <LocalDBWarningBox :warningCount="warningCount" :key="warningCount"/>
        </div>
        <v-container fluid>
            <v-card elevation="0" class="px-5">
                <div class="d-flex mb-4">
                    <h2>{{ $t("deforestation.localDBVerification") }}
                        <v-tooltip top color="00BD73" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                    <v-icon class="icon-with-background primary--text" style="color:#0EBF67" v-bind="attrs"
                                        v-on="on">
                                        mdi-alert-circle
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t("deforestation.locationVerificationTT") }}</span>
                        </v-tooltip>
                    </h2>
                    <v-spacer></v-spacer>
                </div>
                <v-card-text>
                    <v-data-table 
                     :headers="headers" 
                     :items="deforestationComplianceReports" 
                     :items-per-page="10"  
                     hide-default-footer 
                     :loading="loading" 
                     :options.sync="options"
                     :loading-text="$t('loadingData')">
                        <template v-slot:top="{ }">
                            <div class="d-flex justify-space-between filter-pro-places">
                                <div class="d-flex align-center">
                                        <label for="text">&nbsp;</label>
                                    <v-text-field prepend-inner-icon="mdi-magnify" height="5px"
                                        :placeholder="$t('search')"  dense v-model="search" @input="filterProductionPlaces"
                                        class="shrink" v-bind="getTextFieldProps()">
                                    </v-text-field>

                                    <v-select class="mx-2" v-model="productionPlaceInput.farmOwner" item-text="fullName" item-value="fullName"
                                        :items="producerLists" :label="$t('deforestation.producer')" @change="filterProductionPlaces"
                                        outlined dense>
                                    </v-select>

                                    <v-autocomplete v-model="countryModel" item-text="name" item-value="name"
                                    :items="pcountries" class="mx-2" :label="$t('deforestation.producerCountry')" @change="filterProductionPlaces"
                                    dense v-bind="getSelectProps()">
                                    </v-autocomplete>

                                    <v-checkbox label="Show Farm With Issues" v-model="issue_farm" @change="handleCheckboxWithIssue"></v-checkbox>

                                    <!-- <div class="d-flex justify-center align-center mb-5">
                                        <v-checkbox :label="$t('dueDiligence.onlyShowFarmsWithIssues')"></v-checkbox>
                                    </div> -->
                                </div>
                                    <div class="d-flex mb-5 pagination">
                                        <div class="py-1 title">
                                            {{ from }} - {{ to }} of {{ totalProductionPlaces }}
                                        </div>
                                        <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page <= 1"
                                            @click="pageChange(false)" v-bind="getButtonProps()">
                                            <v-icon dark>
                                                mdi-chevron-left
                                            </v-icon>
                                        </v-btn>
                                        <v-btn class="mx-2" fab small outlined color="primary"
                                            :disabled="options.page >= totalPages" @click="pageChange(true)" v-bind="getButtonProps()">
                                            <v-icon dark>
                                                mdi-chevron-right
                                            </v-icon>
                                        </v-btn>

                                        <v-btn class="mx-2" fab small outlined color="primary" v-bind="getButtonProps()">
                                                <v-icon dark>
                                                    mdi-tray-arrow-down
                                                </v-icon>
                                    </v-btn>
                                </div>
                                <!-- <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page <= 1"
                                    @click="pageChange(false)">
                                    <v-icon dark>
                                        mdi-chevron-left
                                    </v-icon>
                                </v-btn>
                                <v-btn class="mx-2" fab small outlined color="primary"
                                    :disabled="options.page >= totalPages" @click="pageChange(true)">
                                    <v-icon dark>
                                        mdi-chevron-right
                                    </v-icon>
                                </v-btn> -->

                               
                                <!-- <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn class="mx-2" fab small outlined v-bind="attrs" v-on="on" color="primary">
                                            <v-icon>settings</v-icon>
                                        </v-btn>
                                    </template>
                                <span>{{ $t('deforestation.settings') }}</span>
                                </v-tooltip> -->
                                </div>
                        </template>
                        <template  v-slot:body="{ items }">
                            <tbody v-if="!items.length">
                                <tr class="v-data-table__empty-wrapper">
                                    <td :colspan="headers.length" class="text-center py-6">
                                        <template v-if="loading">
                                            <v-progress-circular indeterminate color="primary" size="24" width="2" class="mr-2" />
                                            {{ $t('loadingData') }}
                                        </template>
                                        <template v-else>{{ $vuetify.lang.t('$vuetify.noDataText') }}</template>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else :style="loading ? 'opacity: 0.5; pointer-events: none;' : ''">
                                <tr v-for="item in items" :key="item.id" style="position: relative; width: 0; height: 0">

                                    <td class="text-truncate">
                                       {{ item?.farm?.farmName }} <br>
                                       {{ item?.farm?.nationalFarmId ?? item?.farm?.id }}
                                    </td>

                                    <td class="text-truncate">
                                        {{ item.farm?.userDdsAssoc?.firstName || '' }} {{ item.farm?.userDdsAssoc?.lastName || '' }}
                                    </td>

                                    <td class="text-truncate">
                                        {{ farmerIdCheck(item?.farm) }}
                                    </td>

                                    <td class="text-truncate" style="max-width: 300px;">
                                        <span v-if="item?.farm?.farmDbCheck?.nationalFarmId">
                                            <v-icon color="primary"> mdi-check </v-icon> Complaint
                                        </span>
                                        <span v-else>
                                            <v-icon color="red"> mdi-cancel </v-icon> Non-Complaint
                                        </span>
                                    </td>

                                    <td class="text-truncate">
                                        <span v-if="item?.farm?.farmDbCheck?.geoOverlapScore >= getLocalDbConfig?.complaint_threshold_rule_2">
                                            <v-icon color="primary"> mdi-check </v-icon> {{ item?.farm?.farmDbCheck?.geoOverlapScore }} %  Overlap
                                        </span>
                                        <span v-else-if="item?.farm?.farmDbCheck?.geoOverlapScore < getLocalDbConfig?.complaint_threshold_rule_2">
                                            <v-icon color="yellow">  mdi-alert </v-icon> {{ item?.farm?.farmDbCheck?.geoOverlapScore }} %  Overlap
                                        </span>
                                        <span v-else>
                                             -
                                        </span>
                                    </td>

                                    <td class="d-flex justify-center align-center ga-3">
                                        <v-menu location="start">
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon>mdi-dots-vertical</v-icon>
                                            </v-btn>
                                            </template>
                                            <v-list>
                                            
                                            <v-list-item>
                                                <v-list-item-title @click="viewEditGeoLocation(item)" class="pointer-cursor">{{ $t('deforestation.edit') }}</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-title @click="viewIndividualRiskMitigation(false,item)" class="pointer-cursor">{{ $t('deforestation.riskMitigation') }}</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item>
                                                <v-list-item-title color="red" class="pointer-cursor" @click="deleteIndividualProductionPlace(item?.farm?.id)">{{ $t('deforestation.delete') }}</v-list-item-title>
                                            </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                        <template v-slot:footer></template>
                    </v-data-table>
                </v-card-text>
                <div class="mt-4">
                    <p> * {{ $t('deforestation.farmIDStatusDescription') }} </p>
                     <v-btn color="primary" @click="viewIndividualRiskMitigation(true)">
                         {{ $t('deforestation.attachOneRiskMitigationForAllNonComplaint') }}
                     </v-btn> &nbsp; &nbsp;
                     <v-btn color="primary" @click="handleClickRemoveIssueFarm">
                        {{ $t('deforestation.removeFarmWithIssue') }}
                     </v-btn>
                </div>   
                <div class="mt-4">
                    <v-col
                    cols="auto"
                    class="align-start d-flex justify-start flex-wrap"
                    style="gap:10px;"
                  >
                    <div v-for="(file, index) in uploadedFileUrls" :key="index">
                      <v-sheet
                        style="border: 1px solid #ccc; border-radius: 0px; background-color: #fafafa; position: relative;"
                        class="d-flex align-center justify-center flex-wrap text-center px-4 mr-2"
                        height="100"
                        width="100"
                        :title="urlToFileName(file.file_path)"
                      >
                        <div v-if="file.id">
                          <v-icon style=" position: absolute; top:0; right:0;" @click="removeFile(file.id)">
                          mdi-trash-can-outline
                          </v-icon>
                        </div>
                        <v-icon
                          dark
                          style="color: green"
                          @click="openFile(file.file_path)"
                        >
                          mdi-eye
                        </v-icon>
                        
                        <div class="wrapped-text">{{ urlToFileName(file.file_path) }}</div>
                      </v-sheet>
                    </div>
                  </v-col>
                </div> 
            </v-card>
        </v-container>

        <!-- View Geolocation components -->

        <ViewGeoLocation 
           v-if="showViewGeofenceMap" 
           :dialog="showViewGeofenceMap" 
           :disableEditGeofence="isEditGeofenceForCurrentItemDisabled" 
           :farmDetails="currentItem"
           @closeViewGeoLocationModal="dismissViewGeoLocationModal"
           @saveViewGeoLocation="dismissViewGeoLocationModal" 
           :diligenceReportId="diligenceId" />

        <!-- Edit geolocation components -->
        <!-- <EditGeoLocation v-if="showEditGeofenceMap" :dialog="showEditGeofenceMap" :farmDetails="currentItem"
            @closeGeoLocationModal="dismissEditGeoLocationModal" @saveEditGeoLocation="saveEditGeoLocationModal" :diligenceReportId="diligenceId" /> -->

        <!-- <ConfirmBox v-if="deleteconfirm" :dialog="deleteconfirm" :title="confirmElements.title"
            :message1="confirmElements.message1" :message2="confirmElements.message2" confirmBtnText="Delete"
            :confirmData="itemToDelete" @continue:action="deleteProductionPlace"
            @cancel:action="deleteconfirm = false" /> -->

         <!-- <ConfirmBox v-if="multipleDeleteConfirm" :dialog="multipleDeleteConfirm" :title="confirmElements.title"
            :message1="confirmElements.message1" :message2="confirmElements.message2" confirmBtnText="Delete"
             @continue:action="deleteMultipleProductionPlace"
            @cancel:action="multipleDeleteConfirm = false" />
            <LocationsModified 
            v-if="showLocationModified"
            :dialog="showLocationModified"
            :diligenceId="diligenceId"
            @closeLocationModifiedModal="dismissLocationModifiedModal"
            @confirmLocation="confirmLocation"
            @confirmProceed="confirmProceed"
            @viewGeofenceMap="viewGeofenceMap"
            @comfirmItemDelete="comfirmItemDelete"
            @getDeforestationEUDR="getProductionPlaces"
            /> -->

         <MitigationDialog
            v-if="showMitigtionModal"
            :dialogU="showMitigtionModal"
            :productionPlaceId="currentItem?.id"
            :productionPlaceDetail="currentItem"
            @closeBulkUpload="showMitigtionModal = false"
            :diligenceReportId="diligenceId"
            :isBulkMode="isBulkMode"
            @mitigated="getProductionPlaces">
        </MitigationDialog>

        <IssueFarmRemoveDialog @continue:action="handleRemoveIssueFarm" v-if="showIssueFarmDialog" :dialog="showIssueFarmDialog" :title="'Confirmation'" :message="'Are you sure you want to remove issue farms from the report.'" />

        <ProcessingDialog
            :dialog="showProcessingDialog"
            @close="onProcessingDialogClose"
            :description="analyzingLocalDB.analyzingDesc"
            :heading="analyzingLocalDB.analyzingStatus"
            :startTimerModel="startTimer"
            :hasTimer="true"
        />
    </div>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import download from "@/mixins/DownloadMixin";
import getPermittedActions from "@/mixins/GetPermittedActions";
import DateMixin from '@/mixins/DateMixin';
//import UnitService from "@/_services/UnitService";
import DeforestationService from "@/_services/DeforestationService";
import ProcessingDialog from '../components/ProcessingDialog.vue';
//import ActivityLogService from "@/_services/ActivityLogService";
//import { Point, Polygon } from '@flatten-js/core';

//import EditGeoLocation from "../components/local-db-verification/EditGeoLocation.vue";
import ViewGeoLocation from "../components/local-db-verification/ViewGeoLocation.vue";
//import ConfirmBox from "@/components/ConfirmBox";
//import LocationsModified from "../components/local-db-verification/LocationsModified.vue";

import { getCountries } from "country-state-picker";
import MitigationDialog from '../components/local-db-verification/MitigationDialog.vue';
import IssueFarmRemoveDialog from '../components/local-db-verification/IssueFarmRemoveDialog.vue'
//import { getGoogleMapsLoader } from '@/mixins/GoogleMapLoaderSingleton';
import { wait } from '@/utils';
import  LocalDBWarningBox  from '../components/LocalDBWarningBox.vue'
import { countryListIncludesCountry } from '@/constants/countryAliases';

export default {
    components: {
        // GmapCluster,
        //EditGeoLocation,
        ViewGeoLocation,
        MitigationDialog,
        ProcessingDialog,
        LocalDBWarningBox,
        IssueFarmRemoveDialog
        //ConfirmBox,
        //LocationsModified
    },
    props: {
        diligenceId: {
            type: Number,
            required: true,
        },
    },
    async mounted() {
        if(this.diligenceId){
            this.$store.dispatch('eudrDDS/setDiligenceData', {
                diligenceId: this.diligenceId
            })
        }
        //await this.getProductionPlaces()
        await this.getRecentReportDBCheckJob()
        await this.getProductionPlaceLocalDBWarning()
    },
    computed: {
        pcountries(){
            return [{ name: "All Countries" }, ...getCountries()];
        },
        getOrganizationId() {
            return this.$store.getters.getUser?.user_organization?.id;
        },
        getLocalDbConfig(){
            const settings = localStorage.getItem('EUDR_Settings')
            const es =  settings ? JSON.parse(settings) : null   
            return es?.local_db_verification_config ? JSON.parse(es?.local_db_verification_config) : null 
        }
    },
    watch: {
       
    },
    data() {
        return {
            countryOfProduction: [],
            productionPlaceWarnings:[],
            showIssueFarmDialog:false,
            warningCount: 0,
            issue_farm:false,
            showProcessingDialog:false,
            netArea:'',
            showMitigtionModal:false,
            showViewGeofenceMap: false,
            isEditGeofenceForCurrentItemDisabled:false,
            isBulkMode:false,
            uploadedFileUrls:[],
            analyzingLocalDB:{
                analyzingStatus : this.$t('deforestation.processingDialogLocalDB.modalHeader'),
                analyzingDesc: this.$t('deforestation.processingDialogLocalDB.modalDescription_second')
            },
            startTimer: 0,
            farm: {
                name: "",
                registrationNo: "",
                govRegistrationNo: "",
                farmType: "",
                farmOwner: null,
                lat: "",
                log: "",
                farmOwnershipType: "personal",
                country: "",
                state: "",
                city: "",
                countryId: null,
                stateId: null,
                cityId: null,
                address: "",
                area: "",
                areaUomId: 2,
                parameter: 0,
                parameterUomId: 0,
                street: "",
                farmSize: 0,
                farmSizeUomId: 0,
                farmPerimeter: 0,
                farmPerimeterUomId: 1,
                farmGeofence: [],
                farmingGoalOptId: null,
                productionType: "",
                certifications: [],
                farmingGoalsIds: [],
                farmerFirstName: "",
                farmerMiddleName: "",
                farmerLastName: "",
                isTechnician: false,
                technicianId: null,
                farmerId: "",
                userId: "",
                farmGeofenceName: "",
                farmGeofenceCategory: "",
                farmTitleDocument: "",
                farmTitleDocumentUrl: "",
            },
            countryModel: [],
            statusModel: '',
            regionModel: '',
            countries: [
                { text: this.$t('deforestation.allCountries'), val: '' },
            ],
            allStatus: [
                { text: this.$t('deforestation.select'), val: '' },
                { text: this.$t('deforestation.assessmentIssued'), val: 'REQUESTED' },
                { text: this.$t('deforestation.certificateIssued'), val: 'CERTIFICATE_READY' }
            ],
            allRegions: [
                { text: this.$t('deforestation.allRegions'), val: '' },
            ],
            deforestationComplianceReports: [],
            copyReport: [],
            loading: true,
            
            totalProductionPlaces: 0,
            tab: 0,
            selectedItem: false,
            options: {
                itemsPerPage: 20,
                page: 1
            },
            from: 0,
            to: 0,
            headers: [
                {
                    text: this.$t("deforestation.farmAndFarmId"),
                    align: "start",
                    value: "farm.farmName",
                    class: "black--text",
                    sortable: true,
                },
                {
                    text: this.$t("deforestation.producerName"),
                    align: "start",
                    value: "farm.userDdsAssoc.fullName",
                    class: "black--text",
                    sortable: true,

                },

                {
                    text: this.$t('deforestation.farmerIdCheck'),
                    align: "start",
                    value: "farm.userDdsAssoc.countryId",
                    class: "black--text",
                    sortable: true,

                },
                {
                    text: this.$t("deforestation.farmNationalStatus"),
                    align: "start",
                    value: "farm.address",
                    class: "black--text",
                    sortable: true,
                },
                {
                    text: this.$t("deforestation.geofenceOverlapCheck"),
                    align: "start",
                    value: "",
                    class: "black--text",
                    sortable: false,
                },
                {
                    text: this.$t("deforestation.action"),
                    align: "start",
                    value: "",
                    class: "black--text",
                    sortable: false,
                },
            ],
            breadcrumbs: [
                {
                    text: this.$t("deforestation.dueDeligence"),
                    disabled: false,
                    to: { name: "CreateNewDueDeligenceReport" },
                    exact: true,
                },
                {
                    text: this.$t("deforestation.createNewReport"),
                    disabled: true,
                    href: "breadcrumbs_link_1",
                },
            ],
            productionPlaceInput: {
                page: 1,
                limit: 10,
                searchPhrase: "",
                internalRefNum: "",
                farmCountry: "",
                eudrDeforestationStatus: "",
                farmOwner: "",
                filterByDateOfRegister: null,
                filterByDateOfLastReport: null,
                diligenceReportId: null,
            },
            deleteconfirm: false,
            multipleDeleteConfirm: false,
            confirmElements: {
                title: this.$t('dueDiligence.deleteProductionPlaceData'),
                confirmBtnText: this.$t('dueDiligence.areYouSureYouWantToContinueThisAction'),
                cancelBtnText: this.$t("cancel"),
                confirmData: {},
            },
            itemToDelete: {
                digligenceReportId: null,
                farmId: null
            },
            currentItem: null,
            producerLists: [{id:null, fullName:this.$t('deforestation.allProducer')}],
            totalPages: 1,
            productionPlaceData: [],
            producerModel:'',
            search: "",
            isProducerStore:false,
            isProducerFilterMode:false,
            showLocationModified: false,
        };
    },
    methods: {
        async triggerSubmit() {
            this.$emit("fetchUpdatedProductionPlaceData", this.productionPlaceData);
            this.$emit('fetchStep3WarningData', this.productionPlaceWarnings)
            return {
                warnings: this.warnings
            }
        },
        onProcessingDialogClose(){
            this.$router.push({ name:"dueDiligenceReports" });
        },
        async getRecentReportDBCheckJob(){
          const response = await DeforestationService.getJobByAttr(this.diligenceId, 'DiligenceReportDBCheck')
          if(!response?.data?.getJobByAttr) {
             await this.getProductionPlaces()
             return;
          }
          const job = response?.data?.getJobByAttr;
          if(job?.status == 'Completed' || job?.status == 'Failed'){
            await this.getProductionPlaces()
            return;
          }
          let stopWaiting = false;
          let dialogTimeout;

          this.startTimer++;
          this.showProcessingDialog = true;
          this.stopLoading();
          
          // Set dialog timeout to close after 30 seconds and redirect
          dialogTimeout = setTimeout(() => {
            this.showProcessingDialog = false;
            this.$router.push({ name:"dueDiligenceReports" });
          }, 30000); // 30 seconds timeout for dialog


          while(!stopWaiting) {
            await wait(5000);
            const response = await DeforestationService.getJob(parseInt(job?.id));
            if(response.data?.job.status === 'Failed') {
              if (dialogTimeout) clearTimeout(dialogTimeout);
              this.showProcessingDialog = false;
              throw new Error('An error occurred while fetching the deforestation report.');
            }
            if(response?.data.job.status === 'Completed') {
              if (dialogTimeout) clearTimeout(dialogTimeout);
              this.showProcessingDialog = false;
              this.$notify({
                type: 'success',
                title: 'Success',
                text:"Successfully Checked the Location With Local DB",
              });
              this.progressValue = 100;
              await this.getProductionPlaces();
              break;
            }
          } 
        },
        farmerIdCheck(farm){
           return farm?.farmDbCheck?.farmerIdCheckStatus ?? "Unmatch"   
        },

        dismissViewGeoLocationModal() {
            this.currentItem = null;
            this.showViewGeofenceMap = false;
        },
        viewEditGeoLocation(item){
            this.currentItem = item;
            this.showViewGeofenceMap = true;
        },
        viewIndividualRiskMitigation(bulkMode,item=null){
            this.isBulkMode = bulkMode
            this.currentItem = item
            this.showMitigtionModal = true
        },
        urlToFileName(fileurl){console.log(fileurl)},
        getWarningMessage(item) {
            const { farm } = item;
            const areaInHa = farm && farm.area ? farm.area * 0.404686 : 0;
            if (areaInHa > 4 && item.farmType != 'Polygon') {
                return this.$t('deforestation.farmIsBiggerThan4HectaresItNeedsToBeAPolygon');
            } else {
                return '';
            }
        },
        handleClickRemoveIssueFarm(){
            this.showIssueFarmDialog = true
        },
        async handleRemoveIssueFarm(action){
            this.showIssueFarmDialog = false
            if(!action) return;
            console.log(action)
            this.startLoading()
            await DeforestationService.deleteProductionPlaceDBRemoveIssueFarm({
                diligenceReportId:this.diligenceId,
                type:'DELETE_ISSUE_FARM',
                placeId:null
            }).then(() => {
                this.stopLoading()
                this.getProductionPlaces()
            }).catch(() => {
                this.stopLoading()
            })
        },
        async deleteIndividualProductionPlace(farmId) {
            this.startLoading()
            const params = {
                diligenceReportId: this.diligenceId,
                farmId: parseInt(farmId),
            };
            await DeforestationService.removeFarmFromProductionPlaceListById(params).then(() => {
                this.getProductionPlaces()
                this.stopLoading()
            }).catch(() => {
                this.stopLoading()
            });
        },
        shouldShowWarningIcon(item) {
            return this.shouldShowEditButton(item);
        },
        async handleCheckboxWithIssue(){
            await this.getProductionPlaces()
        },
        async getProductionPlaceLocalDBWarning(){
            this.productionPlaceInput = { 
                ...this.productionPlaceInput,
                 page: this.options.page, 
                 limit : this.options.itemsPerPage, 
                 diligenceReportId: this.diligenceId,
                 searchPhrase:this.search,
                 farmCountry:this.countryModel,
                 issue_farm:this.issue_farm
            }
            DeforestationService.getProductionPlaceLocalDBWarning(this.productionPlaceInput).then(res => {
                this.warningCount  = res.data?.getLocalDbWarning?.length
            }).catch(err => {
                console.log(err)
            })
        },
        async getProductionPlaces(opt = null) {
            // Table loader only; callers that write open/close their own overlay.
            this.loading = true;
            const requestParams = {
                page: this.options.page,
                limit: this.options.itemsPerPage,
                search: this.search,
                isCertified: false,
                organization: this.getOrganizationId,
                
            }
            if (opt?.sortBy?.length) {
                requestParams.orderField = opt.sortBy[0]
                requestParams.order = opt.sortDesc[0] ? 'DESC' : 'ASC'
            }
            this.productionPlaceInput = { 
                ...this.productionPlaceInput,
                 page: this.options.page, 
                 limit : this.options.itemsPerPage, 
                 diligenceReportId: this.diligenceId,
                 searchPhrase:this.search,
                 farmCountry:this.countryModel,
                 issue_farm:this.issue_farm
            }

            DeforestationService.getProductionPlacesForLocalDB(this.productionPlaceInput).then(res => {
                this.deforestationComplianceReports = res.data.productionPlacesForLocalDb.rows
                if(!this.isProducerFilterMode){
                    this.copyReport = res.data.productionPlacesForLocalDb.rows 
                }
                this.totalProductionPlaces = res.data.productionPlacesForLocalDb.totalCount;
                this.totalPages = Math.ceil(this.totalProductionPlaces / this.options.itemsPerPage)
                this.from = (((this.options.page - 1) * this.options.itemsPerPage) + 1)
                this.to = (this.options.page * this.options.itemsPerPage) - (this.options.itemsPerPage - res.data.productionPlacesForLocalDb.rows.length)
                const countryLists = this.deforestationComplianceReports.filter(item => item.country).map((item) => {
                    return {
                        text: item.country,
                        val: item.country
                    }
                })
                const stateLists = this.deforestationComplianceReports.filter(item => item.state).map((item) => {
                    return {
                        text: item.state,
                        val: item.state
                    }
                })
                this.countries = [...this.countries, ...countryLists];
                this.allRegions = [... this.allRegions, ...stateLists];
                this.loading = false

                this.productionPlaceData = this.deforestationComplianceReports.map((item) => {
                    let payloadItem = {
                        userId: parseInt(item?.farm?.userDdsAssoc?.id),
                        aoiId: parseInt(item?.farm?.id),
                        latitude: parseFloat(item?.farm?.lat),
                        longitude: parseFloat(item?.farm?.log),
                        farmType: 'point',
                        areaHa: item.farm?item.farm.area * 0.404686 :0,
                        generateMethod: item.farm?.GeoFences?.[0]?.generateMethod,
                    };

                    if (item.farmType.toLowerCase() === 'point' && item?.farm?.GeoFences.length > 0) {
                        payloadItem.radius = item?.farm?.GeoFences[0]?.geofenceRadius / 1000; //convert radius from m to km;
                        payloadItem.farmType = 'point';
                        payloadItem.latitude = parseFloat(item?.farm?.lat);
                        payloadItem.longitude = parseFloat(item?.farm?.log);
                    } else if (item.farmType.toLowerCase() === 'polygon' && item?.farm?.FarmCoordinates) {
                        payloadItem.coordinates = item?.farm?.FarmCoordinates?.map((coord) => ({
                            latitude: parseFloat(coord.lat),
                            longitude: parseFloat(coord.log),
                        }));
                        payloadItem.farmType = 'polygon'
                    }
                    if(!this.isProducerStore){
                       this.producerLists.push({
                         id:item.farm.userDdsAssoc.id,
                         fullName:`${item.farm.userDdsAssoc.firstName} ${item.farm.userDdsAssoc.lastName}`
                       })
                    }
                    this.netArea = ((this.deforestationComplianceReports.reduce((a,b) => {
                        return a + parseFloat(b.farm.area)
                    },0)) / 2.47).toFixed(2)  

                    return payloadItem;
                    
                });
                this.loading = false
            }).catch(err => {
                this.loading = false
                console.log('Error', err)
            })
        },
        selectItem(item) {
            this.selectedItem = item;
        },
        searchQuery() {
            this.getProductionPlaces();
        },
        resetSearchOnEmpty() {
            this.search = ''
            this.countryModel = ''
            this.statusModel = ''
            this.regionModelregionModel = ''
            this.options = {
                page: 1,
                limit: 10
            }
            this.getProductionPlaces();
        },
        filterProductionPlaces(){
          setTimeout(() => {
            this.isProducerStore = true
            this.getProductionPlaces()
          },1500) 
        },
        
        pageChange(t) {
            if (t) this.options.page = this.options.page + 1;
            else this.options.page = this.options.page - 1;
            this.getProductionPlaces();
        },
        checkProductionPlaceWarning(item){
          const warnings = item.warnings
          let wr = `` 
          const above4ha = this.getAboveFourHectorFarm(item)
          if(!this.countryOfProduction?.length){
            wr +=`${this.$t('deforestation.farmCountryNotDefined')} \n`;
          }
          if(above4ha){
            wr +=`Circular geofence with area greater than 4 HA \n`;
          }
          if(warnings  && warnings.length){
            warnings.forEach(item => {
                if(item.is_ocean){
                   wr += `${this.$t('deforestation.geofenceIsInOcean')} \n`
                } 
                if(item.country && !countryListIncludesCountry(this.countryOfProduction, item.country)){
                    wr += `${ this.$t('deforestation.theGeofencesSupposeToBeIn')} ${this.countryOfProduction.toString()} ${this.$t('deforestation.butItsIn')} ${item.country} \n`
                }
             })
          }
        //   if(!item.warnings){
        //     wr += `Could not verify the geofence yet.`
        //   }
          return wr
        }
    },
    mixins: [loadingMixin, download, getPermittedActions, DateMixin],
};
</script>
<style lang="scss" scoped>
.v-input--reverse .v-input__slot {
  flex-direction: row-reverse;
  justify-content: flex-end;
  .v-application--is-ltr & {
    .v-input--selection-controls__input {
      margin-right: 0;
      margin-left: 8px;
    }
  }
  .v-application--is-rtl & {
    .v-input--selection-controls__input {
      margin-left: 0;
      margin-right: 8px;
    }
  }
}
::v-deep .wdt.v-text-field {
    width: 250px;
}

::v-deep .v-tab:hover {
    background-color: #caf1e2;
    color: $primary_color !important;
}

::v-deep .v-data-table-header span {
    text-transform: none !important;
    color: #ffffff !important;
}

::v-deep .center-content {
    display: flex;
    justify-content: center;
    align-items: center;
}

::v-deep .img-center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 40%;
}
.filter-pro-places {
    flex-direction: column;

    @media (min-width: 1689px) {
        flex-direction: row;

    }
}

.pagination {
    align-self: flex-end;
    @media (min-width: 1689px) {
        align-self: center;
    }
}
::v-deep .pointer-cursor{
    cursor: pointer !important;
}
</style>